import { render, staticRenderFns } from "./carddirec.vue?vue&type=template&id=612a6c01&"
import script from "./carddirec.vue?vue&type=script&lang=js&"
export * from "./carddirec.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports